var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6458 5.09738C14.9865 5.29622 15.1015 5.73362 14.9026 6.07433L10.3174 13.9306C10.3173 13.9308 10.3173 13.9309 10.3172 13.931C10.214 14.1082 10.0739 14.2611 9.90645 14.3793C9.74012 14.4967 9.55064 14.5772 9.35071 14.6154C9.14829 14.6555 8.93948 14.6504 8.73924 14.6003C8.53933 14.5503 8.35295 14.4568 8.19338 14.3265L5.2681 11.9863C4.96006 11.7399 4.91011 11.2904 5.15655 10.9824C5.40298 10.6743 5.85248 10.6244 6.16052 10.8708L9.08411 13.2097L13.6688 5.35423C13.8677 5.01353 14.3051 4.89853 14.6458 5.09738Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.42857C5.26613 1.42857 1.42857 5.26613 1.42857 10C1.42857 14.7339 5.26613 18.5714 10 18.5714C14.7339 18.5714 18.5714 14.7339 18.5714 10C18.5714 5.26613 14.7339 1.42857 10 1.42857ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickV2);
export default __webpack_public_path__ + "static/media/tick-v2.e161c03b886f2161ea3cde8d60c66ff5.svg";
export { ForwardRef as ReactComponent };